import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserInfoStore } from '@shared/index';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="unauthorized-wrapper">
      <div class="unauthorized-card">
        <div class="status-code">403</div>
        <h1>Access Denied</h1>
        <p>
          Your account <strong>{{ userRole() }}</strong> does not have permission
          to view this page.
        </p>
        <div class="actions">
          <button class="btn-primary" (click)="goHome()">Go to Home</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .unauthorized-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      background: var(--mat-sys-surface, #f5f5f5);
    }
    .unauthorized-card {
      text-align: center;
      padding: 48px 56px;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 4px 24px rgba(0,0,0,.08);
      max-width: 420px;
    }
    .status-code {
      font-size: 80px;
      font-weight: 700;
      line-height: 1;
      color: var(--mat-sys-primary, #1976d2);
      margin-bottom: 16px;
    }
    h1 {
      margin: 0 0 12px;
      font-size: 24px;
      font-weight: 600;
    }
    p {
      margin: 0 0 32px;
      color: #666;
      line-height: 1.6;
    }
    .btn-primary {
      padding: 10px 28px;
      border: none;
      border-radius: 6px;
      background: var(--mat-sys-primary, #1976d2);
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: opacity 150ms;
    }
    .btn-primary:hover { opacity: .88; }
  `],
})
export class UnauthorizedComponent {
  private readonly router = inject(Router);
  private readonly userInfoStore = inject(UserInfoStore);

  readonly userRole = this.userInfoStore.role;

  goHome(): void {
    this.router.navigate(['/app']);
  }
}
